<template>
  <div class="aside-menu">
    <div class="back" @click="handleRouterBack"></div>
    <!-- 角色切换 -->
    <div class="switch" @click="$emit('switch')"></div>
    <div :class="['menu-item', activeMenu === 1 ? 'menu-item-active' : '']" @click="activeMenu = 1">
      <div class="txt-box">
        <span class="txt">基础</span>
        <span v-if="activeMenu === 1" class="sub-txt">NIKKE</span>
      </div>
    </div>
    <div :class="['menu-item', activeMenu === 2 ? 'menu-item-active' : '']" @click="activeMenu = 2">
      <div class="txt-box">
        <span class="txt">档案</span>
        <span v-if="activeMenu === 2" class="sub-txt">NIKKE</span>
      </div>
    </div>
    <div :class="['menu-item', activeMenu === 3 ? 'menu-item-active' : '']" @click="activeMenu = 3">
      <div class="txt-box">
        <span class="txt">语音</span>
        <span v-if="activeMenu === 3" class="sub-txt">NIKKE</span>
      </div>
    </div>
    <div :class="['menu-item', activeMenu === 4 ? 'menu-item-active' : '']" @click="activeMenu = 4">
      <div class="txt-box">
        <span class="txt">好感度</span>
        <span v-if="activeMenu === 4" class="sub-txt">NIKKE</span>
      </div>
    </div>
    <div :class="['menu-item', activeMenu === 5 ? 'menu-item-active' : '']" @click="activeMenu = 5">
      <div class="txt-box">
        <span class="txt">视频</span>
        <span v-if="activeMenu === 5" class="sub-txt">NIKKE</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AsideMenu",
  props: { value: { type: Number, default: 1 } },
  computed: {
    activeMenu: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    handleRouterBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
.aside-menu {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  user-select: none;
  .back {
    width: 126px;
    height: 34px;
    line-height: 34px;
    background: url("~@/assets/nikke_imgs/back.png") center/cover no-repeat;
    color: #414f6c;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
  }
  .switch {
    width: 126px;
    height: 34px;
    background: url("~@/assets/nikke_imgs/switch-button.png") center/cover no-repeat;
    cursor: pointer;
  }
  .menu-item {
    width: 126px;
    height: 49px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("~@/assets/nikke_imgs/nav-item.png") center/contain no-repeat;
    color: #414f6c;
    font-size: 16px;
    cursor: pointer;
    .txt-box {
      transform: translate(-25px, -12px);
    }
    span {
      transform: translate(-24px, -10px);
    }
  }
  .menu-item-active {
    background: url("~@/assets/nikke_imgs/nav-item-active.png") center/cover no-repeat;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    .txt-box {
      transform: translate(-2px, 1px);
    }
    span {
      transform: translate(0, 0);
    }
  }
  .sub-txt {
    font-size: 14px;
    margin-left: 4px;
    vertical-align: -1px;
    color: rgba(255, 255, 255, 0.65);
  }
}
</style>
